<template>
	<ul class="alert" v-if="errorList.length">
		<li v-for="error in errorList">{{ error }}</li>
	</ul>
</template>

<script>
	export default {
		name: 'ValidationAlert',
		props: {
			errorList: {
				type: Array,
				required: true,
			},
		},
	}
</script>
